import 'core-js/es/map'
import 'core-js/es/set'
import 'core-js/es/array'
import 'raf/polyfill'

import React from 'react'
import ReactDOM from 'react-dom'
import './index.scss'
import AppContainer from './components/AppContainer'

ReactDOM.render(<AppContainer />, document.getElementById('root'))

